import { Foundation } from '@models';

export interface SecurityProjectListResult {
  rootSecurityProjectList: Foundation[];
}
